import logo from './img/logo.svg'
//import './App.css';
import './index.css'; 
import './Chat.css'; 


import { useParams  } from 'react-router-dom';
import React, {useState, useEffect} from 'react'
import { ClientChat } from './modules/Client';
import { ClientChatTemp } from './modules/ClientTemp';
import Config from './Config';

//import NaukaReact from './NaukaReact';
//import List from './List';
//import Layout from './Layout';
//import LayoutSprzedawca from './LayoutSprzedawca';


function App()
 {



  document.title = 'MW - react'
 
  const [userData, setUserData] = useState({
    apiKey: '',
    crypt: '',
    chat_id: '',
    user_type: 'USER',
    saldo: 0,
    email:'',
    expertId: 0,
    client:'',
    orderId:'',
    stawka_klient:'',
  });

  var temp_data = userData;
 
  

  const [refresh,setRefresh] = useState(0);

  if(window.location.origin=='http://localhost:3000')
    var url = window.location.origin;
  else
    var url = window.location.origin+'/react_components/chat';

    

  //localStorage.clear();\

  //console.log('app userData',userData);
 
  const setUser = (user_type,apiKey,chat_id,crypt,saldo,email,expertId,client,orderId,stawka_klient) => {
    setUserData({...temp_data,
      ['user_type']: user_type,
      ['apiKey']: apiKey,
      ['chat_id']: chat_id,
      ['crypt']: crypt,
      ['saldo']: saldo,
      ['email']: email,
      ['expertId']: expertId,
      ['client']: client,
      ['orderId']: orderId,
      ['stawka_klient']: stawka_klient,
    });

    setRefresh(refresh+1);  
   
    return (
      <div>
       
      </div>)
    } 

    const setExpertId = (expertId) => {
      setUserData({...temp_data,
        ['expertId']: expertId,
      });
  
      setRefresh(refresh+1);  
     
      return (
        <div>
          
        </div>)
      } 

      const setEmail = (expertId) => {
        setUserData({...temp_data,
          ['email']: expertId,
        });
    
        setRefresh(refresh+1);  
       
        return (
          <div>
            
          </div>)
        } 

      const setClient = (client) => {
        setUserData({...temp_data,
          ['client']: client,
          
        });
    
        setRefresh(refresh+1);  
       
        return (
          <div>
            
          </div>)
        } 


        const getTempAcc = (client) => {
        
          let sendData = ({
              client:client,
          })
  
          fetch(Config.url+'/rest_public,getTempAcc',{
              method:'POST',
              body: JSON.stringify(sendData), 
              mode:'cors',
              headers: {
                  'Content-Type': 'text/html',
                  'X-API-KEY': userData.apiKey
              }
          })
          .then(res => res.json() )
          .then(res => {
              
  
  
            setUserData({...userData,
              ['user_type']: 'USER',
              ['apiKey']: res.apiKey,
              ['chat_id']: res.chat_id,
              ['crypt']: res.crypt,
              ['saldo']: res.saldo,
              ['email']: res.email_kontakt	,
              ['expertId']: res.id_doradcy	,
              ['client']: res.client,
              ['orderId']: res.orderId,
              ['stawka_klient']: res.stawka_klient,
            });
     
              
          })
          .catch(err => {
              console.log("Err " + err);
          });
  
     
      }    

      var path = window.location.pathname;

      var vars = path.split(/,|;/);
      var client = '';

      

      if(vars.length==4)
      {
        if(vars[2]=='client')
          client = vars[3];
      }

       
      
       if(userData.client=='' && client!='')
       {
          getTempAcc(client);

          return <div>
            trwa ładowanie
          </div>
       }
    

    
 

  /*
  const logout = () => {
    setUser({
      username: '',
      apiKey: '',
      rola: '',
    });
  }
  */
  
  
  //if(user.apiKey.length < 3)
  //{   

  if(userData.chat_id!=='' && userData.chat_id.length>0) 
    {
      return (
        <div className="App">
            <link href={Config.url+'/chat_core/css/main.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/chat.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/notifications.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/switches.css'} rel="stylesheet" />  
            
            <link href={Config.url+'/chat_core/css/sections/intro.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/sections/front.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/sections/cta.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/sections/expert.css'} rel="stylesheet" />
            <link href={Config.url+'/chat_core/css/components/expert-card.css'} rel="stylesheet" />
  
          <ClientChat userData={userData} />
        </div>
        );
      }

      
      return (
        <div>
          
          <link href={Config.url+'/chat_core/css/main.css'} rel="stylesheet" />
          <link href={Config.url+'/chat_core/css/back_main.css'} rel="stylesheet" />
          <link href={Config.url+'/chat_core/css/chat.css'} rel="stylesheet" />
          <link href={Config.url+'/chat_core/css/notifications.css'} rel="stylesheet" />
          <link href={Config.url+'/chat_core/css/switches.css'} rel="stylesheet" />
          <link href={Config.url+'/chat_core/css/sections/forms.css'} rel="stylesheet" />

           
              <main>
                <section class="mw-forms">
                  <div class="mw-container">
                    <ClientChatTemp userData={userData} setUser={setUser} setEmail={setEmail} setExpertId={setExpertId} setClient={setClient}/>
                  </div>
                </section>
              </main>
           
          <br></br>
          <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>

        </div>
      );
      
  //}
  
  if(userData.user_type == 'EXPERT')
  {
      return (
        <div className="App">
            expert
        </div>
      );
  }

  
  
  if(userData.user_type == 'USER_TEMP')
  {
    return (
      <div className="App">
        expert
      </div>
      );
  }

    return (
      <div className="App">
        <span>tester</span>
      </div>
    ); 

}

export default App;
